import { ids } from "@icarros/theme-react";
import styled, { css } from "styled-components";
import { Contrast } from "../../../types/general.types";
import { SectionSizes } from "./constants";
const { text, color } = ids || {};
const defaultStyle = css `
  color: ${color.text.heading.ids_color_text_heading_01};
`;
const onLight = css `
  color: ${color.contrast.ids_color_contrast_onLight};
`;
const onDark = css `
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const section_1 = { ...text.head.ids_textStyle_section_01 };
const section_2 = { ...text.head.ids_textStyle_section_02 };
const getSectionSizeStyle = (size) => {
    switch (size) {
        case SectionSizes.section_1:
            return section_1;
        case SectionSizes.section_2:
            return section_2;
        default:
            return section_1;
    }
};
const getSectionVariantStyle = (contrast) => {
    switch (contrast) {
        case Contrast.dark:
            return onDark;
        case Contrast.light:
            return onLight;
        default:
            return defaultStyle;
    }
};
const StyledSection = styled.div `
  ${({ size }) => getSectionSizeStyle(size)}
  ${({ contrast }) => getSectionVariantStyle(contrast)}
`;
export default StyledSection;
//# sourceMappingURL=Section.style.js.map